<template>
  <div>
    <div v-if="carrierList" class="uk-flex">
      <div style="width:75%">
        <BarEchart v-if="carrierList && carrierList.length" :chartData="setBarEchartData(carrierList)"/>
        <el-empty v-else :description="$t('public.no_data')"></el-empty>

      </div>
      <div style="width: 35%; float:right;">
        <el-table
          :data="carrierList"
          border
          show-summary
          :sum-text="$t('public.total')"
          style="margin-bottom:20px;"
        >
          <el-table-column
            :label="$t('public.carrier_type')"
            width="180"
            >
            <template  slot-scope="scope">
              <span>{{ $t(carrierTypeConvert(scope.row.typeId).title) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="carrierNum"
            :label="$t('public.amount')"
          >
          </el-table-column>
          <el-table-column
            prop="carrierDeviceNum"
            :label="$t('public.installation_point_num')">
          </el-table-column>
        </el-table>
        <el-button type="primary" style="width:35%;margin-right:20px;" @click="handleDetail">{{ $t('public.btn_view')}}{{ $t('public.detail')}}</el-button>
        <el-button type="primary" style="width:60%;" @click="handleDataRate">{{ $t('public.data_rate')}}</el-button>
      </div>
    </div>
    <el-empty v-else :description="$t('public.no_data')"></el-empty>

    <CarrierDetail v-if="isShowDetail" :isShow="isShowDetail"
     :sceneIds="sceneIds"
     @close="isShowDetail = false"/>

     <DataRate v-if="isShowDataRate" :isShow="isShowDataRate"
     :sceneIds="sceneIds"
     @close="isShowDataRate = false"/>
  </div>
</template>
<script>
import { getCarrierList } from '@/api/modules/overview.js'
import { deviceTypeConvert, deviceStatusConvert, carrierTypeConvert } from '@/utils/convert.js'
import BarEchart from '@/components/echart/barEchart.vue';
import CarrierDetail from '../carrier/carrierDetail.vue';
import DataRate from '../carrier/dataRate.vue';

export default {
  props: {
    sceneIds: {
      type: Array,
      default: () => []
    }
  },
  components: {
    BarEchart,
    CarrierDetail,
    DataRate
  },
  data(){
    return {
      carrierList: null,
      isShowDetail: false,
      type: '', // 查看详细时设备类型：是传感器还是网关...等

      deviceTypeConvert,
      carrierTypeConvert,

      isShowDataRate: false,
    }
  },
  // created(){
  //   console.log('created????????????=', this.sceneIds)
  //   this.getCarrier()
  // },
  methods: {
    getData(){
      if(this.sceneIds && this.sceneIds.length){
        this.getCarrier()
      }else{
        this.carrierList = null
      }
    },
    getCarrier(){
      console.log('this.sceneIds===', this.sceneIds)
      console.log('this.sceneIds.join()=', this.sceneIds.join())
      getCarrierList({ scenes: this.sceneIds.join() }).then(res => {
        if (res.state.code === 200) {
          this.carrierList = res.result

        }
      })
    },
    setBarEchartData(data){
      let barSeries = {
        xAxis: [],
        series: []
      }
      let arr1 = []
      let arr2 = []
      data.forEach(item => {
        barSeries.xAxis.push(this.$t(carrierTypeConvert(item.typeId).title))
        arr1.push({
          name: this.$t('public.amount'),
          value: item.carrierNum
        })
        arr2.push({
          name: this.$t('public.installation_point_num'),
          value: item.carrierDeviceNum
        })
      })
      barSeries.series.push(arr1)
      barSeries.series.push(arr2)
      return {
        barSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: '',
          name: ''
        }
      }
    },
    setPieEchartData(item){
      // 整理构造饼图数据
      let pieSeries = []

      for(let key in item){
        if(key !== 'totalCount'){
          pieSeries.push({
            name: deviceStatusConvert(key),
            value: item[key]
          })
        }
      }
      return {
        pieSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: '',
          name: ''
        }
      }
    },
    handleDetail(key){
      this.type = key
      this.isShowDetail = true
    },
    handleDataRate(){
      this.isShowDataRate = true
    }
  }
}
</script>
<style lang="scss" scoped>
.dev-div {
  width: 280px;
  text-align: center;
  margin: 10px;
  .el-row {
    height: 30px;
    line-height: 30px;
    border-bottom: 1px solid #CCCCCC;;
  }
}

.echarts {
  width: 100%;
  height: 250px !important;
}

</style>
